// Plain-language description of where the current theme comes from.
export function describeTheme(eff, presets, settings) {
  if (!eff) return { name: "", source: "" };
  const s = settings || eff;
  const byId = Object.fromEntries(presets.map((p) => [p.id, p]));
  if (s.mode === "preset" && byId[s.preset_id]) return { name: byId[s.preset_id].name, source: "Your personal theme" };
  if (s.mode === "custom") {
    const from = byId[s.preset_id]?.name || `clinic theme (${eff.clinic.preset_name})`;
    return { name: "Custom colours", source: `Your custom theme, based on ${from}` };
  }
  return { name: eff.clinic.preset_name, source: "Clinic default" };
}
